import React from 'react';

import SchoolDetail from './SchoolDetail';
import Layout from '../../components/Layout';

async function action(context) {
  return {
    component: (
      <Layout>
        <SchoolDetail pathname={context.pathname} />
      </Layout>
    ),
  };
}

export default action;
